import React from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';
import { GuestListTableContainer } from '../dues/dues.style';
import ComplaintsWidget from '../home/widgets/complaints';
// import {useHistory } from 'react-router-dom';
// import Cookies from 'js-cookie';



function ComplaintsPageWidget() {
// const history = useHistory()
// const [checked, setChecked] = React.useState(false)
// const facilityId = Cookies.get('facilityId');


  return (
    <div className=''>
        <br/><br/>
        <div className='row'>
            <div className='col s12 m3'>
            <PageTitleText>
                Complaints
            </PageTitleText>
            </div>
            
        </div>  
        <GuestListTableContainer>
            <ComplaintsWidget/>
        </GuestListTableContainer>

       
      

    </div>
  )
}

export default ComplaintsPageWidget